import wx from 'weixin-js-sdk'
import { GetWxJsSdkConfigPara,GetWxSharePara } from './api.js'

let jsApiList = [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareWeibo',
    'onMenuShareQQ',
    'onMenuShareQZone',
    'hideMenuItems',
    'showMenuItems',
    'chooseWXPay',
]
let userAgent = navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
let isWeixin = userAgent && userAgent[0] === 'micromessenger';
let url = window.location.href.split('#')[0];
export function config(callback) {
    GetWxJsSdkConfigPara({ url: encodeURIComponent(url) }).then(r => {
        if (r.suc == 1) {
            let data = r.data;
            wx.config({
                debug: false,
                appId: data.AppId,
                timestamp: data.TimeStamp,
                nonceStr: data.NonceStr,
                signature: data.SignaTure,
                jsApiList: jsApiList,
            });
            wx.ready(function() {
                callback && callback()
            })
            wx.error(function(res) {
                // console.log('weixin:' + r.msg)
            })
        }
    }).catch(error=>{
        console.log(error)
    })
}

export function configAppoint() {
    GetWxSharePara({ url: url }).then(r => {
        if (r.Result == 1) {
            let data = r.Data;
            wx.config({
                debug: false,
                appId: data.AppId,
                timestamp: data.TimeStamp,
                nonceStr: data.NonceStr,
                signature: data.SignaTure,
                jsApiList: jsApiList,
            });
            wx.ready(function() {
                 // 分享给好友
                wx.updateAppMessageShareData({
                    title:'预约有礼-工业服务未来发展论坛',// 分享标题
                    desc: '暨《中国工业服务产业发展白皮书》发布会',// 分享描述
                    link: `${window.location.origin}/#/forum?link=forum`,// 分享链接
                    imgUrl: "https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/icon/share.png",// 分享图标
                    success: function(){
                        console.log('成功！')
                    },
                    cancel:function(){
                        console.log('失败！')
                    }
                })
                // 分享到朋友圈
                wx.updateTimelineShareData({
                    title:'预约有礼-工业服务未来发展论坛',// 分享标题
                    link: `${window.location.origin}/#/forum?link=forum`,// 分享链接
                    imgUrl: "https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/icon/share.png",// 分享图标
                    success:function(){
                        console.log('成功2！')
                    },
                    cancel:function(){
                        console.log('失败2！')
                    }
                })
            })
            wx.error(function(res) {
                console.log('weixin:' + res.errMsg)
            })
        }
    })
}

export function share(data,callback) {
    isWeixin && wx && wx.checkJsApi && wx.checkJsApi({
        jsApiList: jsApiList,
        success: function(res) {
            res.checkResult.updateAppMessageShareData && wx.updateAppMessageShareData({
                title: data.title, // 分享标题
                desc: data.desc, // 分享描述
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function(d) {
                    console.log(d)
                    // 用户确认分享后执行的回调函数
                    console.log('成功2')
                    alert('成功2')
                    data.success && data.success('朋友')
                    callback && callback()
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                    alert('失败2')
                    data.cancel && data.cancel('朋友')
                }
            })

            res.checkResult.updateTimelineShareData && wx.updateTimelineShareData({
                title: data.title, // 分享标题
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function() {
                    // 用户确认分享后执行的回调函数
                    data.success && data.success('朋友圈')
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                    data.cancel && data.cancel('朋友圈')
                }
            })

            res.checkResult.onMenuShareQQ && wx.onMenuShareQQ({
                title: data.title, // 分享标题
                desc: data.desc, // 分享描述
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function() {
                    // 用户确认分享后执行的回调函数
                    data.success && data.success('QQ')
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                    data.cancel && data.cancel('QQ')
                }
            })

            res.checkResult.onMenuShareQZone && wx.onMenuShareQZone({
                title: data.title, // 分享标题
                desc: data.desc, // 分享描述
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function() {
                    // 用户确认分享后执行的回调函数
                    data.success && data.success('QQ')
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                    data.cancel && data.cancel('QQ')
                }
            })

            res.checkResult.onMenuShareWeibo && wx.onMenuShareWeibo({
                title: data.title, // 分享标题
                desc: data.desc, // 分享描述
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function() {
                    // 用户确认分享后执行的回调函数
                    data.success && data.success('微博')
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                    data.cancel && data.cancel('微博')
                }
            })
        }
    })
}